module.exports = __webpack_public_path__ + "assets/img/i11.77d6da73.png";